import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ConfigService } from "src/app/core/config.service";
import { CicdRepositoryDetails, CicdRepositories, CicdRepositoriesChartsData} from "./cicd-repositories.model";
import { CicdRepositoryTypeEnum } from "src/app/shared/enum/cicd-repository-type.enum";

@Injectable({
    providedIn: 'root'
})
export class CicdRepositoriesService {

    constructor(private httpClient: HttpClient, private configService: ConfigService){

    }

    loadCicdGitlabRepositories(){
        return this.httpClient.get<CicdRepositories>(`${this.configService.config.apiUrl}/cicd/repositories/gitlab`)
        .pipe(
            map((response=>{
                const data = []
                const repositoryEnumKeys = Object.keys(CicdRepositoryTypeEnum);
                for(let type in response){
                    const repositories = response[type as keyof CicdRepositories]
                    if(repositoryEnumKeys.includes(type)){
                        data.push(...repositories.checked.map((value) => {return {...value, type: type, allBranches: value.checked.concat(value.unchecked)}}))
                        data.push(...repositories.unchecked.map((value) => {return {...value, type: type, allBranches: value.checked.concat(value.unchecked)}}))
                        data.push(...repositories.ignored.map((value) => {return {...value, type: type, allBranches: value.checked.concat(value.unchecked)}}))
                    }
                }
                return data
            }))
        )
    }

    loadCicdGitlabRepositoryDetails(repositoryId: string){
        return this.httpClient.get<CicdRepositoryDetails>(`${this.configService.config.apiUrl}/cicd/repositories/gitlab/details?repository_id=${repositoryId}`)
    }

    loadCicdGitlabRepositoriesMeasures(start_date: string, end_date: string, granularity: string){
        return this.httpClient.get<CicdRepositoriesChartsData>(`${this.configService.config.apiUrl}/cicd/repositories/gitlab/measures?start_date=${start_date}&end_date=${end_date}&granularity=${granularity}`)
    }
}
